import { IBlock, IQuickReplyBlock } from 'common/builder/blocks/blockInterfaces'
import {
  BlockConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { getButtonsFromMap } from 'common/builder/components/chart/FlowChart/lib/utils/getButtonsFromMap'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { FlowChartButton } from 'common/builder/components/chart/FlowChart/types/FlowChartButton'
import { FlowChartQuickRepliesBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartQuickRepliesBlock'
import { BlockType } from 'common/builder/constants/BlockType'

const fallbackButtonSorter = (buttonA: FlowChartButton, buttonB: FlowChartButton) => {
  const aIsFallback = buttonA?.isFallback
  const bIsFallback = buttonB?.isFallback

  if (aIsFallback === bIsFallback) {
    return 0
  }

  if (aIsFallback) {
    return 1
  }

  if (bIsFallback) {
    return -1
  }

  return 0
}

export const QuickRepliesBlockGenericConverterRule: ConverterRule<
  IQuickReplyBlock,
  FlowChartQuickRepliesBlock,
  BlockConverterRulePayload
> = {
  predicate: (entity: IBlock) => entity?.type === BlockType.QUICK_REPLY,
  convert: (entity: IQuickReplyBlock, { flowChartButtons }) => {
    const buttons = getButtonsFromMap(entity.buttons, flowChartButtons).sort(fallbackButtonSorter)

    if (buttons.length === 0) {
      return null
    }

    return {
      id: entity.id,
      type: FlowChartBlockType.QUICK_REPLIES,
      data: {
        buttons,
      },
    }
  },
}
